module.exports = __webpack_public_path__ + "img/375.609cf172.jpg";